import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import Util from '../util';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { ProjectCommunicationService } from '../communication/project-comms.service';
import { ResultSetConfigService } from './results-helper/result-set-config.service';
import { UserpilotReloader } from '../helper/userpilot-reloader.component';

@Component({
  selector: 'app-results-component',
  templateUrl: './results.component.html',
  styleUrls: [],
  providers: [ResultSetConfigService]
})
export class ResultsComponent extends UserpilotReloader implements OnInit, OnDestroy {
  onDestroyNotifier = new EventEmitter();


  constructor(private authService: AuthService,
              private router: Router,
              private projectCommService: ProjectCommunicationService
  ) {
    super();
  }

  ngOnInit() {
    this.projectCommService.loadResults();
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  isLoggedIn() {
    return this.authService.isLoggedIn();
  }

  isProjectLoaded() {
    return Util.isProjectLoaded();
  }

  showHistoryPicker() {
    return this.isLoggedIn() && this.isProjectLoaded() && this.router.url.match('baseline');
  }
}
